import config from '../../../config/config';
import getRequest from '../base/get';

interface QueryParameters {
  limit?: number;
  [key: string]: any;
}

export default {
  /**
   * Fetch the Accounts list with pagination
   * @param {any} query - The query
   * @returns {Promise<any>} The API response
   */
  fetchCommercialTransactionList: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query, limit: query?.limit || 5 };
    return getRequest(`${config.emsp.transactionApiUrl}api/emsp/v1/cdrs`, {
      ...parameters,
    });
  },
  /**
   * Fetch the Accounts list with pagination version 2
   * @param {any} query - The query
   * @returns {Promise<any>} The API response
   */
  fetchPersonalTransactionList: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query, limit: query?.limit || 5 };
    return getRequest(`${config.emsp.sessionsApiUrl}api/emsp/v1/personal-charging-transaction`, {
      ...parameters,
    });
  },
  /**
   * Fetch the Accounts list with pagination
   * @returns {Promise<any>} The API response
   */
  fetchCommercialTransactionListFilters: (): Promise<any> => {
    return getRequest(`${config.emsp.transactionApiUrl}api/emsp/v1/cdrs/list-filters`);
  },
  /**
   * Fetch maintenance schedule API for export
   * @param {any} query - The query parameters
   * @returns {any} A promise that resolves with the exported data
   */
  fetchCommercialTransactionExport: (query: QueryParameters = {}) => {
    const parameters = { ...query };
    return getRequest(`${config.emsp.transactionApiUrl}api/emsp/v1/cdrs/export`, {
      ...parameters,
    });
  },
  /**
   * Fetch charge order details for a session
   * @param {string} sessionId - The session identifier
   * @returns {Promise<any>} The API response
   */
  fetchChargeOrder: (sessionId: string): Promise<any> => {
    return getRequest(`${config.emsp.emspApiUrl}api/v1/sessions/${sessionId}/charge-order`);
  },
  /**
   * Fetch payment attempts and timeline for a session
   * @param {string} sessionId - The session identifier
   * @param {any} [query] - The query parameters
   * @returns {Promise<any>} The API response
   */
  fetchPaymentAttempts: (sessionId: string, query: QueryParameters | string = {}): Promise<any> => {
    const parameters = typeof query === 'string' ? { authReference: query } : { ...query };
    return getRequest(`${config.emsp.emspApiUrl}api/v1/sessions/${sessionId}/payment-attempts`, {
      ...parameters,
    });
  },
};
